export const emailVerificationURL = () => window.location.origin.concat('/verify');

export const recoverPasswordURL = () => window.location.origin.concat('/recover-password');

export const redirectToHttps = () => {
    if (location.protocol !== 'https:') {
        location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    }
};

export const getDomainName = () => {
    let domain = window.location.origin;
    domain = domain.replace('http://', '');
    domain = domain.replace('https://', '');
    return domain;
};

export const getMainDomainUrl = () => {
    let domain = window.location.hostname;

    if (domain == '127.0.0.1') {
        return domain;
    }

    // Remove subdomain if exists
    const firstDotIndex = domain.indexOf('.');
    if (firstDotIndex !== -1) {
        const secondDotIndex = domain.indexOf('.');
        // if secondDotIndex is not -1, the domain then contains a subdomain
        if (secondDotIndex !== -1) {
            domain = domain.substring(firstDotIndex);
        }
    }

    return domain;
};

export const getSubDomain = () => {
    let domain = window.location.hostname;
    if (domain == '127.0.0.1') {
        return null;
    }
    const indexOfDot = domain.indexOf('.');
    return indexOfDot !== -1 ? domain.substring(0, indexOfDot) : null;
};

export const objectToQueryString = queryObject => {
    return '?'.concat(
        Object.keys(queryObject)
            .map(key => key.concat('=', queryObject[key], '&'))
            .join()
    );
};

// https://stackoverflow.com/questions/8486099/how-do-i-parse-a-url-query-parameters-in-javascript
export const getJsonFromUrl = url => {
    if (!url) url = location.href;
    let question = url.indexOf('?');
    let hash = url.indexOf('#');
    if (hash === -1 && question === -1) return {};
    if (hash === -1) hash = url.length;
    let query =
        question === -1 || hash === question + 1
            ? url.substring(hash)
            : url.substring(question + 1, hash);
    let result = {};
    query.split('&').forEach(function(part) {
        if (!part) return;
        part = part.split('+').join(' '); // replace every + with space, regexp-free version
        let eq = part.indexOf('=');
        let key = eq > -1 ? part.substr(0, eq) : part;
        let val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
        let from = key.indexOf('[');
        if (from === -1) result[decodeURIComponent(key)] = val;
        else {
            let to = key.indexOf(']', from);
            let index = decodeURIComponent(key.substring(from + 1, to));
            key = decodeURIComponent(key.substring(0, from));
            if (!result[key]) result[key] = [];
            if (!index) result[key].push(val);
            else result[key][index] = val;
        }
    });
    return result;
};
